import React, { useState } from 'react';
import './css/About.css'; // Dedicated page styles
import { useNavigate } from "react-router-dom";


// Reusing your standalone, modular layout components
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Import your custom images here
import aboutHeroBg from '../images/banner-about.png';
import aboutDetailsImg from '../images/AboutRight.png';

// Import your custom images here at the top
import featureSectionBg from '../images/Banner5.png'; // New Background Import
import featureSectionBg2 from '../images/Banner3.png'; // New Background Import



// React Icons (Using react-icons/fa or similar icon framework)
import {
    FaBullseye,
    FaHandshake,
    FaShieldAlt,
    FaHeart,
    FaUsers,
    FaUserCog,
    FaClipboardCheck,
    FaLaptopCode
} from "react-icons/fa";

import DownloadApp from './components/DownloadApp';

function About() {
    const navigate = useNavigate();




    return (
        <div className="about-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="about-hero-section"
                style={{ backgroundImage: `url(${aboutHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Core Narrative & Brand Pillars Section */}
            <section className="about-details-section">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Left Column: Contextual Narrative */}
                        <div className="col-lg-6">

                            <p className="info-small-text">
                                DISCOVER FIXOVERA
                            </p>

                            <h2 className="about-section-heading">
                                Reliable Home Services, Right at Your Doorstep
                            </h2>

                            <div className="zigzag-divider mb-4"></div>

                            <p className="about-body-text">
                                Fixovera is a digital home services marketplace that connects
                                customers with trusted professionals for everyday home
                                maintenance, repair, cleaning, and improvement needs.
                            </p>

                            <p className="about-body-text highlighted-paragraph">
                                From AC servicing and appliance repairs to installation, maintenance,
                                and other essential home appliance services, Fixovera makes it simple
                                to discover, book, and manage reliable professional services from one
                                convenient platform.
                            </p>


                            {/* Metric Pillars Grid */}
                            <div className="row g-3 mt-4">

                                <div className="col-sm-4">
                                    <div className="metric-box box-blue">

                                        <h3 style={{ color: "#fff" }}>
                                            7+
                                        </h3>

                                        <p
                                            style={{
                                                color: "#fff",
                                                fontSize: "11px"
                                            }}
                                        >
                                            Home Services
                                        </p>

                                    </div>
                                </div>


                                <div className="col-sm-4">
                                    <div className="metric-box box-yellow">

                                        <h3 style={{ color: "#fff" }}>
                                            24/7
                                        </h3>

                                        <p style={{ color: "#fff" }}>
                                            Easy Booking
                                        </p>

                                    </div>
                                </div>


                                <div className="col-sm-4">
                                    <div className="metric-box box-teal">

                                        <h3 style={{ color: "#fff" }}>
                                            TRUSTED
                                        </h3>

                                        <p
                                            style={{
                                                color: "#fff",
                                                fontSize: "11px"
                                            }}
                                        >
                                            Service Professionals
                                        </p>

                                    </div>
                                </div>

                            </div>

                        </div>

                        {/* Right Column: Clean, Unboxed Raw Image Layout */}
                        <div className="col-lg-6 text-center">
                            <img
                                src={aboutDetailsImg}
                                alt="Enterprise Architecture"
                                className="img-fluid"
                                style={{
                                    border: "none",
                                    boxShadow: "none",
                                    outline: "none",
                                    borderRadius: 0,
                                    background: "transparent",
                                    display: "block",
                                    margin: "0 auto"
                                }}
                            />
                        </div>

                    </div>
                </div>
            </section>



            {/* 4. Glassmorphic Grid Services / Capabilities Section */}
            <section className="about-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
                <div className="container">

                    {/* Centralized Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">

                            <span className="grid-section-mini-tag">
                                WHY FIXOVERA
                            </span>

                            <h2 className="grid-section-heading">
                                Our Mission, Approach & Commitment
                            </h2>

                            <div className="zigzag-border mx-auto mt-3"></div>

                        </div>
                    </div>


                    {/* 2 Cards Per Row */}
                    <div className="row g-4 justify-content-center">


                        {/* Mission */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <FaBullseye className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Our Mission</h4>

                                        <p>
                                            Fixovera's mission is to make professional home
                                            services simple, accessible, and reliable for
                                            every household. We connect customers with
                                            skilled service professionals while creating a
                                            convenient and transparent experience from
                                            booking to completion.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Approach */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-yellow">
                                        <FaHandshake className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Our Approach</h4>

                                        <p>
                                            We follow a customer-first approach that focuses
                                            on convenience, transparency, and dependable
                                            service. From discovering the right service to
                                            scheduling and completing a booking, Fixovera
                                            brings the entire home service experience into
                                            one easy-to-use platform.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Quality & Safety */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-teal">
                                        <FaShieldAlt className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Quality & Safety</h4>

                                        <p>
                                            We focus on connecting customers with capable
                                            service professionals and maintaining a
                                            dependable service ecosystem. Our platform is
                                            designed to support transparent bookings,
                                            professional service delivery, and a safer
                                            experience for both customers and service
                                            providers.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Our Commitment */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <FaHeart className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Our Commitment</h4>

                                        <p>
                                            Fixovera is committed to making everyday home
                                            maintenance easier and more dependable. We
                                            continuously work to improve the customer
                                            experience, support service professionals, and
                                            build a trusted ecosystem where quality service
                                            is just a few steps away.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* --- NEW SECTION INSERTION --- */}
            <section className="about-feature-grid-offset-section" style={{ backgroundImage: `url(${featureSectionBg})` }}>
                <div className="container py-5">
                    <div className="row align-items-center g-5">
                        {/* Left Column Content */}
                        {/* Left Column Content */}
                        <div className="col-lg-5">

                            <p className="info-small-text">
                                OUR TEAM
                            </p>

                            <h2 className="about-section-heading">
                                People & Professionals Powering Better Home Services
                            </h2>

                            <div className="zigzag-divider mb-4"></div>

                            <p className="about-body-text">
                                Fixovera is powered by a dedicated team of technology
                                professionals, service experts, operations specialists, and
                                customer experience teams working together to simplify
                                everyday home services.
                            </p>

                            <p className="about-body-text mt-3">
                                From building a seamless digital platform to supporting service
                                professionals and ensuring a smooth customer experience, our
                                team is focused on making home maintenance more convenient,
                                transparent, and reliable.
                            </p>

                        </div>


                        {/* Right Column: Fixovera Ecosystem */}
                        <div className="col-lg-7">

                            <div className="row g-4">

                                {/* Left Column */}
                                <div className="col-sm-6 d-flex flex-column gap-4 staggered-left-col">

                                    {/* Customers */}
                                    <div className="staggered-box box-theme-1">

                                        <div className="staggered-icon-circle">
                                            <FaUsers className="staggered-icon" />
                                        </div>

                                        <h4 className="staggered-box-heading">
                                            Customers
                                        </h4>

                                    </div>


                                    {/* Service Professionals */}
                                    <div className="staggered-box box-theme-2">

                                        <div className="staggered-icon-circle">
                                            <FaUserCog className="staggered-icon" />
                                        </div>

                                        <h4 className="staggered-box-heading">
                                            Service Professionals
                                        </h4>

                                    </div>

                                </div>


                                {/* Right Column */}
                                <div className="col-sm-6 d-flex flex-column gap-4 pt-sm-5 staggered-right-col">

                                    {/* Operations */}
                                    <div
                                        className="staggered-box box-theme-3"
                                        onClick={() => navigate("/founders")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="staggered-icon-circle">
                                            <FaClipboardCheck className="staggered-icon" />
                                        </div>

                                        <h4 className="staggered-box-heading">
                                            Operations Team
                                        </h4>
                                    </div>


                                    {/* Technology */}
                                    <div className="staggered-box box-theme-4">

                                        <div className="staggered-icon-circle">
                                            <FaLaptopCode className="staggered-icon" />
                                        </div>

                                        <h4 className="staggered-box-heading">
                                            Technology Team
                                        </h4>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default About;